import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeDropdown, openDropdown, setHoveredRubric } from '../../actions/dropdown';
import { closeMenu, openMenu } from '../../actions/menu';
import { Menu } from '../../components/Menu/Menu';
import { selectActiveRubric } from '../../selectors/dropdown';
import { selectMenuStatus } from '../../selectors/menu/selectMenuStatus';
import { ERubric } from '../../types/rubricsLinks';
import { useApplicationContext } from '../../utils/applicationContext';

interface IMenuContainerProps {
  menuRef: React.RefObject<HTMLButtonElement>;
}

export const MenuContainer: React.FC<IMenuContainerProps> = ({ menuRef }) => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();
  const isOpen = useSelector(selectMenuStatus);
  const activeRubric = useSelector(selectActiveRubric);
  const isMenuEnabled = config.get<boolean>('header-frontend.menuButton.Enabled') ?? false;

  const handleMenuClick = () => {
    if (!isOpen) {
      dispatch(openMenu());
      dispatch(openDropdown());
      dispatch(setHoveredRubric(activeRubric || ERubric.Rent));
    } else {
      dispatch(closeMenu());
      dispatch(closeDropdown());
    }
  };

  if (!isMenuEnabled) {
    return null;
  }

  return <Menu isOpen={isOpen} buttonRef={menuRef} handleMenuClick={handleMenuClick} />;
};
